// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__C0MtQ","download":"styles_download__KiO+C","pdf":"styles_pdf__JIDv0","buttons":"styles_buttons__ZkiSs"};